import turfFn from "@turf/boolean-within";

export default function booleanWithin(feature1, feature2) {
    return turfFn(feature1, feature2);
}
